/**
 * The roster's field vocabulary — client-safe (the stal tray imports it):
 * the horse statuses with their Dutch labels and the override fields the
 * `/portal/roster` action accepts (ADR-020: never "H1/H2" in copy).
 */
export const HORSE_STATUSES = [
	'rijklaar',
	'dagje_vrij',
	'rust_herstel',
	'ziek',
] as const
export type HorseStatus = (typeof HORSE_STATUSES)[number]
export const HORSE_STATUS_LABELS_NL: Record<HorseStatus, string> = {
	rijklaar: 'rijklaar',
	dagje_vrij: 'dagje vrij',
	rust_herstel: 'rust en herstel',
	ziek: 'ziek',
}

export const OVERRIDE_FIELDS = [
	'skip',
	'eExpected',
	'eArrival',
	'h1Rider',
	'h2Rider',
	'muckingDuty',
	'onSite',
	'activityNl',
] as const
export type OverrideField = (typeof OVERRIDE_FIELDS)[number]

export const WEEKDAY_LABELS_NL = [
	'zondag',
	'maandag',
	'dinsdag',
	'woensdag',
	'donderdag',
	'vrijdag',
	'zaterdag',
] as const

export const WEEKDAY_SHORT_NL = [
	'zo',
	'ma',
	'di',
	'wo',
	'do',
	'vr',
	'za',
] as const

// Monday-first display order, like the carers' xlsx.
export const WEEKDAY_DISPLAY_ORDER = [1, 2, 3, 4, 5, 6, 0] as const
